import {
  PersonMatchProfile,
  AddPersonMatchProfilePayload,
} from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useAddPersonMatchProfile(
  onSuccess?: (data: PersonMatchProfile) => void,
  onError?: (err: Error) => void
) {
  const url = `/v2/orm/person_profile`;

  const request = new Request(url, {
    method: 'POST',
  });

  return useAuthenticatedMutation<
    PersonMatchProfile,
    AddPersonMatchProfilePayload
  >(request, {
    onSuccessInvalidationKeys: [['person_match_profiles']],
    onSuccess,
    onError,
    getBody: (data) => JSON.stringify([data]),
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson as PersonMatchProfile;
    },
  });
}

export default useAddPersonMatchProfile;
